<template>
  <v-container fluid>
    <v-breadcrumbs :items="breadItems"
                   class="breadcrumb mx-8">
    </v-breadcrumbs>

    <!-- <v-card style="border-radius: 15px"> -->
    <v-row dense
           class="d-flex mx-8"
           v-show="spliceVariant.length > 0"
           v-for="(item,index) in spliceVariant"
           :key="index">
      <v-col cols="10"
             sm="10"
             md="10"
             lg="10">

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <!-- <span v-bind="attrs"
                  v-on="on">This text has a tooltip</span> -->
            <v-card-title class="justify-center"
                          v-bind="attrs"
                          v-on="on"><span class="info--text font-weight-bold">Event ID</span>: {{item.event_id}}</v-card-title>
          </template>
          <span>Gene _ Chromsome _ Strand _ AS Type _ Event Coordinates</span>
        </v-tooltip>
      </v-col>

      <v-col cols="9"
             sm="9"
             md="9"
             lg="9">
        <v-expansion-panels multiple
                            focusable
                            class="data-table-style"
                            v-model="panels">
          <v-expansion-panel id="description">
            <v-expansion-panel-header class="font-weight-bold">
              <span class="text-decoration-underline">Splicing Event Description</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row dense>
                <v-col cols="8">
                  <v-card color="rgb(245, 177, 73)"
                          outlined
                          class="mt-2">
                    <v-list dense>
                      <v-list-item>
                        <v-list-item-content class="align-start"
                                             style="max-width:30%">
                          <span class="font-weight-bold">Regulatory Mechanism: </span>
                          <!-- {{item.regulatory_mechanism}} -->
                        </v-list-item-content>
                        <v-list-item-content class="align-start"
                                             style="max-width:70%">
                          {{item.regulatory_mechanism}}
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item>
                        <v-list-item-content class="font-weight-bold"
                                             style="max-width:30%">Splicing Regulators:</v-list-item-content>
                        <v-list-item-content class="align-start"
                                             style="max-width:70%"
                                             v-if="item.regulatory_gene && item.regulatory_gene != '-'">
                          <span v-for="(regulator, index) in item.regulatory_gene && item.regulatory_gene.split(', ')"
                                :key="index"
                                class="v-item-group">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn color="rgb(245, 177, 73)"
                                       class="mr-1"
                                       outlined
                                       small
                                       v-bind="attrs"
                                       v-on="on"
                                       :disabled="regulator == '-'"
                                       @click="goToRegualtionNetwork(regulator)">
                                  {{regulator}}
                                </v-btn>
                              </template>
                              <span>Click to jump to the Splicing Regulatory Network</span>
                            </v-tooltip>
                          </span>
                        </v-list-item-content>
                        <v-list-item-content v-else>
                          <span>{{item.regulatory_gene}}</span>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
                <v-col cols="4"
                       class="d-flex flex-column justify-center align-center">
                  <div class="d-flex flex-row">
                    <span v-show="item.regulatory_mechanism == '-' || item.regulatory_mechanism == ''">
                      <v-chip class="mr-1 my-1">
                        Unknown
                      </v-chip>
                    </span>
                  </div>
                  <div class="d-flex flex-row">
                    <span v-show="item.regulatory_mechanism && item.regulatory_mechanism != '-'"
                          v-for="(mechanism, index) in item.regulatory_mechanism && item.regulatory_mechanism.split(', ')"
                          :key="index"
                          class="v-item-group">
                      <v-chip class="mr-1 my-1">
                        {{mechanism}}
                      </v-chip>
                    </span>
                  </div>
                  <div class="d-flex flex-row">
                    <span v-show="item.regulatory_gene && item.regulatory_gene != '-'"
                          v-for="(regulator, index) in item.regulatory_gene && item.regulatory_gene.split(', ')"
                          :key="index+'-'"
                          class="v-item-group">
                      <v-chip class="mr-1 my-1"
                              color="rgb(245, 177, 73)"
                              :disabled="regulator == '-'"
                              @click="goToRegualtionNetwork(regulator)">
                        {{regulator}}
                      </v-chip>
                    </span>
                  </div>
                </v-col>

                <v-col cols="8">
                  <div class="d-flex justify-center"
                       id="arrow1">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         version="1.1"
                         height='30px'
                         width="100%">
                      <marker id='markerArrow1'
                              markerUnits='strokeWidth'
                              refX='6'
                              refY='6'
                              markerHeight='12'
                              markerWidth='12'
                              orient='auto'>
                        <path d='M2,2 L10,6 L2,10 L6,6 L2,2'
                              style='fill:rgb(245, 177, 73)' />
                      </marker>
                      <!-- <line x1='320'
                            y1='5'
                            x2='320'
                            y2='20'
                            stroke='#BDBDBD'
                            stroke-width='2'
                            marker-end='url(#markerArrow)'>
                      </line> -->
                    </svg>
                  </div>
                </v-col>
                <v-col cols="4">
                  <div class="d-flex justify-center"
                       id="arrow3">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         version="1.1"
                         height='30px'
                         width="100%">
                      <marker id='markerArrow1'
                              markerUnits='strokeWidth'
                              refX='6'
                              refY='6'
                              markerHeight='12'
                              markerWidth='12'
                              orient='auto'>
                        <path d='M2,2 L10,6 L2,10 L6,6 L2,2'
                              style='fill:#E57373' />
                      </marker>
                    </svg>
                  </div>
                </v-col>

                <v-col cols="8">
                  <v-card color="rgb(114, 187, 232)"
                          outlined
                          id="event-info">
                    <!-- <v-card-title class="white--text">Splicing Event</v-card-title> -->
                    <v-list dense>
                      <v-list-item>
                        <v-list-item-content class="font-weight-bold"
                                             style="max-width:30%">AS Event Type:</v-list-item-content>
                        <v-list-item-content style="max-width:70%">
                          {{item.as_type}}
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item>
                        <v-list-item-content class="font-weight-bold"
                                             style="max-width:30%">Related Exons:</v-list-item-content>
                        <v-list-item-content style="max-width:70%">
                          {{item.related_exons}}
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item>
                        <v-list-item-content class="font-weight-bold"
                                             style="max-width:30%">Event Coordinates:</v-list-item-content>
                        <v-list-item-content style="max-width:70%">
                          <span v-show="item.event_coordinates != '-'">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn @click="goToVisualiztion(item.gene_name, item.as_type, 
                  item.event_coordinates)"
                                       class="mx-0"
                                       color="rgb(114, 187, 232)"
                                       outlined
                                       small
                                       v-bind="attrs"
                                       v-on="on"
                                       :disabled="item.as_type == 'Complex'">{{item.event_coordinates}}</v-btn>
                              </template>
                              <span>Click to jump to the Splicing Visualization</span>
                            </v-tooltip>
                          </span>
                          <span v-show="item.event_coordinates == '-'">
                            {{item.event_coordinates}}
                          </span>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item>
                        <v-list-item-content class="font-weight-bold"
                                             style="max-width:30%">Alt Region Coordinates:</v-list-item-content>
                        <v-list-item-content style="max-width:70%">
                          {{item.alt_coordinates}}
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item>
                        <v-list-item-content class="font-weight-bold"
                                             style="max-width:30%">Splice-in Isoforms:</v-list-item-content>
                        <v-list-item-content style="max-width:70%">
                          {{item.splice_in_isoforms}}
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item>
                        <v-list-item-content class="font-weight-bold"
                                             style="max-width:30%">Splice-out Isoforms:</v-list-item-content>
                        <v-list-item-content style="max-width:70%">
                          {{item.splice_out_isoforms}}
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item>
                        <v-list-item-content class="font-weight-bold"
                                             style="max-width:30%">ORF Annotation:</v-list-item-content>
                        <v-list-item-content style="max-width:70%">
                          {{item.orf_annotation}}
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
                <v-col cols="4"
                       v-if="item.as_type != 'Complex'">
                  <div id="as-model">
                    <svg></svg>
                  </div>
                </v-col>
                <v-col cols="4"
                       class="d-flex justify-center align-center"
                       v-if="item.as_type == 'Complex'">
                  <span>
                    <v-chip class="mr-1 my-1">
                      Complex
                    </v-chip>
                  </span>
                </v-col>

                <v-col cols="8">
                  <div class="d-flex justify-center"
                       id="arrow2">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         version="1.1"
                         height='30px'
                         width="100%">
                      <marker id='markerArrow2'
                              markerUnits='strokeWidth'
                              refX='6'
                              refY='6'
                              markerHeight='12'
                              markerWidth='12'
                              orient='auto'>
                        <path d='M2,2 L10,6 L2,10 L6,6 L2,2'
                              style='fill:rgb(114, 187, 232)' />
                      </marker>
                    </svg>
                  </div>
                </v-col>
                <v-col cols="4">
                  <div class="d-flex justify-center"
                       id="arrow4">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         version="1.1"
                         height='30px'
                         width="100%">
                      <marker id='markerArrow2'
                              markerUnits='strokeWidth'
                              refX='6'
                              refY='6'
                              markerHeight='12'
                              markerWidth='12'
                              orient='auto'>
                        <path d='M2,2 L10,6 L2,10 L6,6 L2,2'
                              style='fill:#8E24AA' />
                      </marker>
                    </svg>
                  </div>
                </v-col>

                <v-col cols="8">
                  <v-card color="rgb(165, 212, 172)"
                          outlined>
                    <v-list dense>
                      <v-list-item>
                        <v-list-item-content class="font-weight-bold"
                                             style="max-width:30%">Biological Function:</v-list-item-content>
                        <v-list-item-content class="align-start"
                                             style="max-width:70%">
                          <span v-for="(biofunc, index) in item.biological_function && item.biological_function.split(', ')"
                                :key="index"
                                class="v-item-group"
                                v-show="item.biological_function != '-'">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn class="mr-1"
                                       color="rgb(165, 212, 172)"
                                       outlined
                                       small
                                       v-bind="attrs"
                                       v-on="on"
                                       :disabled="biofunc == '-'"
                                       @click="goToSplicingEffect(biofunc)">{{biofunc}}</v-btn>
                              </template>
                              <span>Click to jump to the Splicing Effect</span>
                            </v-tooltip>
                          </span>
                          <span v-show="item.biological_function == '-'">
                            {{item.biological_function}}
                          </span>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item>
                        <v-list-item-content class="font-weight-bold"
                                             style="max-width:30%">Functional Description:</v-list-item-content>
                        <v-list-item-content class="align-start"
                                             style="max-width:70%">
                          {{item.functional_description}}
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
                <v-col cols="4"
                       class="d-flex justify-center align-center">
                  <span v-for="(biofunc, index) in item.biological_function && item.biological_function.split(', ')"
                        :key="index"
                        class="v-item-group"
                        v-show="item.biological_function != '-'">
                    <v-chip class="mr-1"
                            color="rgb(165, 212, 172)"
                            :disabled="biofunc == '-'"
                            @click="goToSplicingEffect(biofunc)">{{biofunc}}</v-chip>
                  </span>
                  <span v-show="item.biological_function == '-'">
                    {{item.biological_function}}
                  </span>
                </v-col>
              </v-row>

            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel id="method">
            <v-expansion-panel-header class="font-weight-bold">
              <span class="text-decoration-underline">Sample & Method Information</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-list dense
                      v-for="item in spliceVariant"
                      :key="item._id">
                <v-list-item>
                  <v-list-item-content class="font-weight-bold">Cancer Type</v-list-item-content>
                  <v-list-item-content class="align-end">
                    {{item.cancer_name}}
                  </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item>
                  <v-list-item-content class="font-weight-bold">Primary Site</v-list-item-content>
                  <v-list-item-content class="align-end">
                    {{item.primary_site}}
                  </v-list-item-content>
                </v-list-item>

                <v-list-item v-show="item.samples != '-'">
                  <v-list-item-content class="font-weight-bold">Sample</v-list-item-content>
                  <v-list-item-content class="align-end">
                    {{item.samples}}
                  </v-list-item-content>
                </v-list-item>

                <v-list-item v-show="item.cell_line != '-'">
                  <v-list-item-content class="font-weight-bold">Cell Line</v-list-item-content>
                  <v-list-item-content class="align-end">
                    {{item.cell_line}}
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>

                <v-list-item v-show="item.methods != '-'">
                  <v-list-item-content class="font-weight-bold">Experimental Method</v-list-item-content>
                  <v-list-item-content class="align-end">
                    {{item.methods}}
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-show="item.primer_f != '-'">
                  <v-list-item-content class="font-weight-bold">Primer (Forward)</v-list-item-content>
                  <v-list-item-content class="align-end">
                    {{item.primer_f}}
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-show="item.primer_r != '-'">
                  <v-list-item-content class="font-weight-bold">Primer (Reverse)</v-list-item-content>
                  <v-list-item-content class="align-end">
                    {{item.primer_r}}
                  </v-list-item-content>
                </v-list-item>
                <v-divider v-show="item.external_intervention != '-'"></v-divider>

                <v-list-item v-show="item.external_intervention != '-'">
                  <v-list-item-content class="font-weight-bold">External Intervention</v-list-item-content>
                  <v-list-item-content class="align-end">
                    {{item.external_intervention}}
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel id="literature">
            <v-expansion-panel-header class="font-weight-bold">
              <span class="text-decoration-underline">Literature Information</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-list dense
                      v-for="item in spliceVariant"
                      :key="item._id">
                <v-list-item>
                  <v-list-item-content class="font-weight-bold">Year</v-list-item-content>
                  <v-list-item-content class="align-end">
                    {{item.year}}
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>

                <v-list-item>
                  <v-list-item-content class="font-weight-bold">PubMed ID</v-list-item-content>
                  <v-list-item-content class="align-end">
                    <a :href="pubmedLink+item.pubmed_id"
                       target="_blank">{{item.pubmed_id}}</a>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>

                <v-list-item>
                  <v-list-item-content class="font-weight-bold">Journal</v-list-item-content>
                  <v-list-item-content class="align-end">
                    {{item.journal}}
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>

                <v-list-item>
                  <v-list-item-content class="font-weight-bold">Title</v-list-item-content>
                  <v-list-item-content class="align-end">
                    {{item.title}}
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel id="psi-boxplot">
            <v-expansion-panel-header class="font-weight-bold">
              <span>
                <span class="text-decoration-underline">PSI Distribution of Splicing Event in TCGA Pan-Cancer</span>
                <span class="mx-2">
                  <v-dialog v-model="dialog"
                            :retain-focus="false">
                    <template v-slot:activator="{  }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn color=""
                                 icon
                                 x-small
                                 @click.stop="dialog=true"
                                 v-bind="attrs"
                                 v-on="on"
                                 class="">
                            <v-icon>mdi-help-circle</v-icon>
                          </v-btn>
                        </template>
                        <span>Click here to get the extension of tumor abbreviations.</span>
                      </v-tooltip>
                    </template>
                    <v-card style="left:25%; width:50%">
                      <v-card-title class="font-weight-bold grey lighten-2"
                                    style="padding:0px 0px 0px 20px">
                        TCGA Project ID - Project Name
                        <v-spacer></v-spacer>
                        <v-btn icon
                               large
                               @click="dialog = false">
                          <v-icon>mdi-close-circle</v-icon>
                        </v-btn>
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-simple-table dense
                                      fixed-header
                                      height="600px">
                        <template v-slot:default>
                          <thead class="font-weight-bold">
                            <tr>
                              <th class="text-left"
                                  style="width:30%">Project ID</th>
                              <th class="text-left"
                                  style="width:70%">Project Name</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>TCGA-ACC</td>
                              <td>Adrenocortical Carcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-BLCA</td>
                              <td>Bladder Urothelial Carcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-BRCA</td>
                              <td>Breast Invasive Carcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-CESC</td>
                              <td>Cervical Squamous Cell Carcinoma and Endocervical Adenocarcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-CHOL</td>
                              <td>Cholangiocarcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-COAD</td>
                              <td>Colon Adenocarcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-DLBC</td>
                              <td>Lymphoid Neoplasm Diffuse Large B-cell Lymphoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-ESCA</td>
                              <td>Esophageal Carcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-GBM</td>
                              <td>Glioblastoma Multiforme</td>
                            </tr>
                            <tr>
                              <td>TCGA-HNSC</td>
                              <td>Head and Neck Squamous Cell Carcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-KICH</td>
                              <td>Kidney Chromophobe</td>
                            </tr>
                            <tr>
                              <td>TCGA-KIRC</td>
                              <td>Kidney Renal Clear Cell Carcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-KIRP</td>
                              <td>Kidney Renal Papillary Cell Carcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-LGG</td>
                              <td>Brain Lower Grade Glioma</td>
                            </tr>
                            <tr>
                              <td>TCGA-LIHC</td>
                              <td>Liver Hepatocellular Carcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-LUAD</td>
                              <td>Lung Adenocarcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-LUSC</td>
                              <td>Lung Squamous Cell Carcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-MESO</td>
                              <td>Mesothelioma</td>
                            </tr>
                            <tr>
                              <td>TCGA-OV</td>
                              <td>Ovarian Serous Cystadenocarcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-PAAD</td>
                              <td>Pancreatic Adenocarcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-PCPG</td>
                              <td>Pheochromocytoma and Paraganglioma</td>
                            </tr>
                            <tr>
                              <td>TCGA-PRAD</td>
                              <td>Prostate Adenocarcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-READ</td>
                              <td>Rectum Adenocarcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-SARC</td>
                              <td>Sarcoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-SKCM</td>
                              <td>Skin Cutaneous Melanoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-STAD</td>
                              <td>Stomach Adenocarcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-TGCT</td>
                              <td>Testicular Germ Cell Tumors</td>
                            </tr>
                            <tr>
                              <td>TCGA-THCA</td>
                              <td>Thyroid Carcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-THYM</td>
                              <td>Thymoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-UCEC</td>
                              <td>Uterine Corpus Endometrial Carcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-UCS</td>
                              <td>Uterine Carcinosarcoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-UVM</td>
                              <td>Uveal Melanoma</td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-card>
                  </v-dialog>
                </span>
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content v-if="isShowPsiBoxPlot">
              <event-pancancer-psi ref="event_psi"
                                   :event-id="selected_event"
                                   @isshow="isShowPsiPancanBoxplot"></event-pancancer-psi>
            </v-expansion-panel-content>
            <v-expansion-panel-content v-else
                                       class="mt-1">
              <span>Sorry, there is no PSI values for this splicing events.</span>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel id="ct">
            <v-expansion-panel-header class="font-weight-bold">
              <span class="text-decoration-underline">Canonical Transcript</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-list dense
                      v-for="(item,index) in spliceVariant"
                      :key="index">
                <v-list-item>
                  <v-list-item-content class="font-weight-bold">Canonical Transcript ID</v-list-item-content>
                  <v-list-item-content class="align-end">
                    {{item.canonical_transcript_id}}
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content class="font-weight-bold">Ensembl Transcript ID</v-list-item-content>
                  <!-- NA don't need to add link -->
                  <v-list-item-content class="align-end"
                                       v-show="item.ct_ensembl_id !== '-'">
                    <a :href="ensemblLink+item.ct_ensembl_id"
                       target="_blank">{{item.ct_ensembl_id}}</a>
                  </v-list-item-content>
                  <v-list-item-content class="align-end"
                                       v-show="item.ct_ensembl_id === '-'">
                    {{item.ct_ensembl_id}}
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content class="font-weight-bold">RefSeq ID</v-list-item-content>
                  <v-list-item-content class="align-end"
                                       v-show="item.ct_refSeq_id !== '-'">
                    <a :href="refseqLink+item.ct_refSeq_id"
                       target="_blank">{{item.ct_refSeq_id}}</a>
                  </v-list-item-content>
                  <v-list-item-content class="align-end"
                                       v-show="item.ct_refSeq_id === '-'">
                    {{item.ct_refSeq_id}}
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content class="font-weight-bold">Transcript Description</v-list-item-content>
                  <!-- if length < 100, show it directly -->
                  <v-list-item-content class="align-end description"
                                       v-if="item.canonical_transcript_description.length < 100">
                    {{item.canonical_transcript_description}}
                  </v-list-item-content>
                  <!-- if length > 100, show more and less based in click events.-->
                  <v-list-item-content class="align-end description"
                                       v-else
                                       v-show="fold1">
                    {{item.canonical_transcript_description | ellipsis}}
                    <v-tooltip right>
                      <template v-slot:activator="{ on, attrs }">
                        <a @click='fold1 = !fold1'
                           v-show="fold1"
                           class="font-weight-bold"
                           v-bind="attrs"
                           v-on="on">more</a>
                      </template>
                      <span>click me show more.</span>
                    </v-tooltip>
                  </v-list-item-content>
                  <v-list-item-content class="align-end description"
                                       v-show="!fold1">
                    {{item.canonical_transcript_description}}
                    <v-tooltip right>
                      <template v-slot:activator="{ on, attrs }">
                        <a @click='fold1 = !fold1'
                           v-show="!fold1"
                           class="font-weight-bold"
                           v-bind="attrs"
                           v-on="on">less</a>
                      </template>
                      <span>click me show less.</span>
                    </v-tooltip>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel id="sv">
            <v-expansion-panel-header class="font-weight-bold">
              <span class="text-decoration-underline">Splicing Variant</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-list dense
                      v-for="item in spliceVariant"
                      :key="item._id">
                <v-list-item>
                  <v-list-item-content class="font-weight-bold">Splicing Variant ID</v-list-item-content>
                  <v-list-item-content class="align-end">
                    {{item.splice_variant_id}}
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content class="font-weight-bold">Ensembl Transcript ID</v-list-item-content>
                  <v-list-item-content class="align-end"
                                       v-show="item.sv_ensembl_id !== '-'">
                    <a :href="ensemblLink+item.sv_ensembl_id"
                       target="_blank">{{item.sv_ensembl_id}}</a>
                  </v-list-item-content>
                  <v-list-item-content class="align-end"
                                       v-show="item.sv_ensembl_id === '-'">
                    {{item.sv_ensembl_id}}
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content class="font-weight-bold">RefSeq ID</v-list-item-content>
                  <v-list-item-content class="align-end"
                                       v-show="item.sv_refSeq_id !== '-'">
                    <a :href="refseqLink+item.sv_refSeq_id"
                       target="_blank">{{item.sv_refSeq_id}}</a>
                  </v-list-item-content>
                  <v-list-item-content class="align-end"
                                       v-show="item.sv_refSeq_id === '-'">
                    {{item.sv_refSeq_id}}
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content class="font-weight-bold">Transcript Description</v-list-item-content>
                  <v-list-item-content class="align-end description"
                                       v-if="item.splice_variant_description.length < 100">
                    {{item.splice_variant_description}}
                  </v-list-item-content>
                  <v-list-item-content class="align-end description"
                                       v-else
                                       v-show="fold2">
                    {{item.splice_variant_description | ellipsis}}
                    <v-tooltip right>
                      <template v-slot:activator="{ on, attrs }">
                        <a @click='fold2 = !fold2'
                           v-show="fold2"
                           class="font-weight-bold"
                           v-bind="attrs"
                           v-on="on">more</a>
                      </template>
                      <span>click me show more.</span>
                    </v-tooltip>
                  </v-list-item-content>
                  <v-list-item-content class="align-end description"
                                       v-show="!fold2">
                    {{item.splice_variant_description }}
                    <v-tooltip right>
                      <template v-slot:activator="{ on, attrs }">
                        <a @click='fold2 = !fold2'
                           v-show="!fold2"
                           class="font-weight-bold"
                           v-bind="attrs"
                           v-on="on">less</a>
                      </template>
                      <span>click me show less.</span>
                    </v-tooltip>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>

      <v-col cols="3"
             sm="3"
             md="3"
             lg="3"
             class="side_bar">
        <v-list dense
                outlined
                rounded>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="d-flex justify-center font-weight-bold">
                <span style="font-size: 1rem !important;">Table of Contents</span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!-- <v-divider></v-divider> -->
          <div class="d-flex justify-center font-weight-bold">
            <v-chip outlined
                    small
                    color="success"
                    class="mx-2"
                    @click="showAll()">
              Show All
            </v-chip>
            <v-chip outlined
                    small
                    color="error"
                    class="mx-2"
                    @click="showNone()">
              Collapse All
            </v-chip>
          </div>
          <v-divider class="my-2"></v-divider>

          <v-list-item-group v-model="panels"
                             multiple
                             color="info">
            <v-list-item v-for="(item, index) in itemsList"
                         :key="index"
                         @click="goToAnchor(item.url, index)">
              <v-list-item-content>
                <v-list-item-title>
                  {{index+1}}. {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>
    </v-row>

    <back-to-top></back-to-top>
    <!-- </v-card> -->
  </v-container>
</template>

<script>
import { getSpliceKnowledge } from 'node/browse';
import EventPancancerPsi from 'views/visualization/EventPancancerPsi';
import * as d3 from 'd3';
import BackToTop from '@/components/main/BackToTop';
import tippy, { followCursor } from 'tippy.js';
import 'tippy.js/dist/tippy.css';

export default {
  name: 'Details',
  components: {
    EventPancancerPsi,
    BackToTop
  },
  data() {
    return {
      breadItems: [
        {
          text: 'Home',
          disabled: false,
          href: '/ascancer/home',
        },
        {
          text: 'Browse',
          disabled: true,
        },
        {
          text: 'CASE',
          disabled: false,
          href: '/ascancer/browse/knowledge',
        },
        {
          text: 'Details',
          disabled: true,
        },
      ],

      data1: [{ "name": "Splicing Regulator", "next": [{ "index": 1 }] },
      { "name": "Splicing Event", "next": [{ "index": 2 }] },
      { "name": "Splicing Effect", "next": [] }],

      itemsList: [
        { title: 'Splicing Event Description', url: '#description' },
        { title: 'Sample & Method Information', url: '#method' },
        { title: 'Literature Information', url: '#literature' },
        { title: 'PSI Distribution of Event in TCGA Pancancer', url: '#psi-boxplot' },
        { title: 'Canonical Transcript', url: '#ct' },
        { title: 'Splicing Variant', url: '#sv' },
      ],
      panels: [0, 1, 2, 3, 4, 5],

      spliceVariant: [],
      as_type: null,
      event_coords: null,
      strand: null,
      related_exons: null,


      fold1: true,
      fold2: true,
      pubmedLink: "https://pubmed.ncbi.nlm.nih.gov/",
      ensemblLink: "https://grch37.ensembl.org/Homo_sapiens/Transcript/Summary?db=core;t=",
      refseqLink: "https://www.ncbi.nlm.nih.gov/nuccore/",

      selected_event: null,
      isShowPsiBoxPlot: true,

      dialog: false,
    }
  },
  created() {
    if (this.$route.query.eventid) {
      this.getSpliceVariantByEventidAndPubmedid();
    }
  },
  mounted() {
    // 必须放在这里，且必须是异步的，不然不能传值给子组件，因为子组件 eventId watch 监听动态改变
    setTimeout(() => {
      let event_id = this.$route.query.eventid;
      this.selected_event = event_id;
      // console.log(this.selected_event);
      this.plotArrow();
    }, 500);
  },
  computed: {
  },
  filters: {
    ellipsis(value) {
      if (value.length > 50) {
        return value.slice(0, 50) + '...'
      }
      return value
    },
  },
  methods: {
    getRequestParams(eventid, cancername, pubmedid, page, pageSize) {
      let params = {};
      if (eventid) {
        params["eventid"] = eventid;
      }
      if (cancername) {
        params["cancername"] = cancername;
      }
      if (pubmedid) {
        params["pubmedid"] = pubmedid;
      }
      if (page) {
        params["page"] = page - 1;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }
      return params;
    },
    async getSpliceVariantByEventidAndPubmedid() {
      let eventid = this.$route.query.eventid;
      let cancername = this.$route.query.cancername;
      // console.log(cancername);
      let pubmedid = this.$route.query.pubmedid;

      const params = this.getRequestParams(
        eventid,
        cancername,
        pubmedid,
        1,
        10
      );
      await getSpliceKnowledge(params).then((result) => {
        // console.log(result);
        this.spliceVariant = result.items;
        // console.log(this.spliceVariant);

        this.strand = result.items && result.items[0].strand;
        this.as_type = result.items && result.items[0].as_type;
        this.event_coords = result.items && result.items[0].event_coordinates;
        this.related_exons = result.items && result.items[0].related_exons;

        setTimeout(() => {
          this.plotASModel();
        }, 100);

      }).catch((err) => {
        console.error(err);
      });
    },
    goToRegualtionNetwork(regulator) {
      // console.log(regulator);
      let regulation;
      if (regulator.includes('(')) {
        regulation = regulator.split('(')[0].trim();
      } else {
        regulation = regulator.trim();
      }
      // console.log(regulation);

      this.$router.push({
        path: '/tools/regnet',
        query: {
          regulator: regulation,
        }
      }).catch(err => {
        if (
          err.name !== 'NavigationDuplicated' &&
          !err.message.includes('Avoided redundant navigation to current location')
        ) {
          // But print any other errors to the console
          logError(err);
        }
      })
    },
    goToVisualiztion(genename, astype, coordinate) {
      this.$router.push({
        path: '/splicevis',
        query: {
          genename: genename,
          astype: astype,
          coordinate: coordinate
        }
      }).catch(err => {
        if (
          err.name !== 'NavigationDuplicated' &&
          !err.message.includes('Avoided redundant navigation to current location')
        ) {
          // But print any other errors to the console
          logError(err);
        }
      })
    },
    goToSplicingEffect(effect) {
      this.$router.push({
        path: '/biofunc',
        query: {
          functional: effect,
          page: 1,
          size: 15,
        }
      }).catch(err => {
        if (
          err.name !== 'NavigationDuplicated' &&
          !err.message.includes('Avoided redundant navigation to current location')
        ) {
          // But print any other errors to the console
          logError(err);
        }
      })
    },
    goToAnchor(selector, index) {
      // console.log(this.panels);
      if (!this.panels.includes(index)) {
        // this.panels.push(index);
        this.panels = [...this.panels, index];
        // this.$set(this.panels, this.panels.length, index);
        // console.log(this.panels);
      } else {
        let i = this.panels.indexOf(index);
        // this.panels.splice(i, 1);
        let panels = [...this.panels]; // 这里必须先替换成非响应式
        // console.log(panels);
        this.panels = panels.splice(i, 1);
      }

      // block: Defines vertical alignment.
      // inline: Defines horizontal alignment.
      // this.$el.querySelector(selector)
      //   .scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
      // console.log(index);

      const scrollToAnimationFn = (number = 0, time) => {
        if (!time) {
          document.body.scrollTop = document.documentElement.scrollTop = number
          return number
        }
        const spacingTime = 20 // 设置循环的间隔时间  值越小消耗性能越高
        let spacingInex = time / spacingTime // 计算循环的次数
        let nowTop = document.body.scrollTop || document.documentElement.scrollTop // 获取当前滚动条位置
        const everTop = (number - nowTop) / spacingInex // 计算每次滑动的距离
        const scrollTimer = setInterval(() => {
          if (spacingInex > 0) {
            spacingInex--
            scrollToAnimationFn((nowTop += everTop))
          } else {
            clearInterval(scrollTimer) // 清除计时器
          }
        }, spacingTime)
      }

      let ele = this.$el.querySelector(selector);
      if (ele) {
        scrollToAnimationFn(ele.offsetTop + 45, 500)
      }
    },
    showAll() {
      this.panels = [0, 1, 2, 3, 4, 5, 6]
    },
    showNone() {
      this.panels = []
    },
    isShowPsiPancanBoxplot(data) {
      // console.log(data);
      this.isShowPsiBoxPlot = data;
    },
    plotArrow() {
      let svg1 = d3.selectAll("div#arrow1 > svg");
      let svg3 = d3.selectAll("div#arrow3 > svg");
      // console.log(svg1);

      let svg2 = d3.selectAll("div#arrow2 > svg");
      let svg4 = d3.selectAll("div#arrow4 > svg");
      // console.log(svg2);

      // console.log(document.getElementById("arrow1"));
      let width1 = document.getElementById("arrow1").offsetWidth;
      // console.log(width1 / 2);
      let arrowLoc1 = width1 / 2;

      let width2 = document.getElementById("arrow3").offsetWidth;
      // console.log(width2 / 2);
      let arrowLoc2 = width2 / 2;

      // plot arrow1 and arrow2
      svg1.append('g').append('line').attr('x1', arrowLoc1).attr('y1', '5')
        .attr('x2', arrowLoc1).attr('y2', '20').attr('stroke', 'rgb(245, 177, 73)')
        .attr('stroke-width', '2').attr('marker-end', 'url(#markerArrow1)')
      svg2.append('g').append('line').attr('x1', arrowLoc1).attr('y1', '5')
        .attr('x2', arrowLoc1).attr('y2', '20').attr('stroke', 'rgb(114, 187, 232)')
        .attr('stroke-width', '2').attr('marker-end', 'url(#markerArrow2)')

      // plot arrow3 and arrow4
      svg3.append('g').append('line').attr('x1', arrowLoc2).attr('y1', '5')
        .attr('x2', arrowLoc2).attr('y2', '20').attr('stroke', 'rgb(245, 177, 73)')
        .attr('stroke-width', '2').attr('marker-end', 'url(#markerArrow1)')
      svg4.append('g').append('line').attr('x1', arrowLoc2).attr('y1', '5')
        .attr('x2', arrowLoc2).attr('y2', '20').attr('stroke', 'rgb(114, 187, 232)')
        .attr('stroke-width', '2').attr('marker-end', 'url(#markerArrow2)')
    },
    plotASModel() {

      const margin = ({ top: 0, right: 10, bottom: 0, left: 10 });
      // const width = 300;
      const width = document.getElementById("arrow3").offsetWidth - 200;
      const height = 150;
      // const height = document.getElementById("event-info").offsetHeight;
      const nodesHeight = height / 2;
      const rectHeight = 15;
      const exonColor = '#42A5F5';
      const asColor = '#FF7043';
      const hoverColor = '#eec42d';

      const svg = d3.select("div#as-model > svg")
        .attr("viewBox", [0, 0, width, height]);
      // console.log(svg);

      let as_type = this.as_type;
      let event_coords = this.event_coords;
      let strand = this.strand;
      let related_exons = this.related_exons;
      related_exons = related_exons.split(', ');

      let arr = event_coords.split(":").map(d => +d).sort((a, b) => a - b) // sort coordinates
      let start = arr[0];
      let end = arr[arr.length - 1];

      let xScale = d3.scaleLinear()
        .domain([start, end])
        .range([margin.left, width - margin.right]);

      ////////////////////////// plot AS Model
      function plotASModel(as_model_exons, as_model_introns) {

        // console.log(as_model_exons);

        let as_model = svg.append("g")
          .attr('class', 'as-model');

        // plot Y axis of AS Model
        let yScale_as_model = d3.scaleBand()
          .domain(as_model_exons.map(function (d) { return d.name; }))
          .range([margin.top, height])
          .padding(1);
        // let yAxis_as_model = d3.axisLeft(yScale_as_model);
        // as_model.append("g")
        //   .attr("class", "y-axis-as-model")
        //   .attr("transform", `translate(${margin.left},${rectHeight / 2})`)
        //   .call(yAxis_as_model)
        //   .call(g => g.select(".domain").remove())
        //   .call(g => g.selectAll('.tick line').remove())
        //   .call(g => g.selectAll('.tick text').style("font-size", "4.5")
        //     .style("font-family", "Arial").style("font-weight", "bold"))

        // plot exons of AS Model
        as_model.append('g')
          .attr("class", "exons-as-model")
          .selectAll()
          .data(as_model_exons)
          .join("rect")
          .attr('x', d => xScale(d.start))
          .attr('y', d => yScale_as_model(d.name))
          .attr('width', d => xScale(d.end) - xScale(d.start))
          .attr('height', rectHeight)
          .attr('rx', 1) // set border-radius
          .attr('stroke', 'rgb(0,0,0)') // set border color
          .attr('stroke-width', 0.3) // set border width
          .attr('fill', d => { return d.color })
          .style("cursor", "auto")
          .attr('clip-path', 'url(#clipRect)')
          .on('mouseover', function () {
            // console.log(as_model_exons);
            d3.select(this).transition().attr('fill', hoverColor);
          })
          .on('mouseout', function () {
            d3.select(this).transition().attr('fill', d => { return d.color });
          });
        // add exons tooltips using Tippy.js
        let exon_rects = d3.selectAll('.exons-as-model rect');
        if (strand == "+") {
          exon_rects.attr('data-tippy-content', (d, i) => {
            return `<div>Exon: ${d.exon}</div>
             <div>Start: ${d.start}</div>
             <div>End: ${d.end}</div>
             <div>Length: ${d.length}</div>`;
          });
        } else {
          exon_rects.attr('data-tippy-content', (d, i) => {
            return `<div>Exon: ${d.exon}</div>
             <div>Start: ${d.end}</div>
             <div>End: ${d.start}</div>
             <div>Length: ${d.length}</div>`;
          });
        }

        tippy(exon_rects.nodes(), {
          allowHTML: true,
          placement: 'left',
          interactive: true,
          interactiveDebounce: 0,
          appendTo: () => document.body,
          // followCursor: 'horizontal',
          // plugins: [followCursor],
          maxWidth: 200,
          delay: 0,
          duration: [0, 0],
        })

        // plot introns of AS Model
        svg.append('g')
          .attr("class", "introns-as-model")
          .selectAll()
          .data(as_model_introns)
          .join('line')
          .attr('x1', d => xScale(d.start)).attr('y1', d => yScale_as_model(d.name))
          .attr('x2', d => xScale(d.end)).attr('y2', d => yScale_as_model(d.name))
          .attr("transform", `translate(0,${rectHeight / 2})`)
          .attr("stroke", "grey")
          .attr("stroke-width", "0.5")
          .attr('clip-path', 'url(#clipRect)')
      }

      ////////////////////////// Plot Links for the AS Event Model
      function plotNodesAndLinks(as_type, nodes_links, arc) {
        let as_model = d3.select('g.as-model');
        // Add the arc for the AS event model (set arc color based on AS Type)
        if (as_type == "ES") {
          as_model.selectAll()
            .data(nodes_links.links)
            .join("path")
            .attr("d", arc)
            .attr("fill", "none")
            .attr("stroke", d => {
              // console.log(nodes_links.links.length);
              // 3 exons(skip 1)
              if (nodes_links.links && nodes_links.links.length == 3) {
                if (d.source == 2 && d.target == 5) {
                  return 'red'
                } else { return 'black' }
                // 4 exons(skip 2)
              } else if (nodes_links.links && nodes_links.links.length == 4) {
                if (d.source == 2 && d.target == 7) {
                  return 'red'
                } else { return 'black' }
                // 5 exons(skip 3)
              } else if (nodes_links.links && nodes_links.links.length == 5) {
                if (d.source == 2 && d.target == 9) {
                  return 'red'
                } else { return 'black' }
              }
            })
            .attr("stroke-width", "0.5")
            .attr('clip-path', 'url(#clipRect)')
        } else if (as_type == "A3SS") {
          as_model.selectAll()
            .data(nodes_links.links)
            .join("path")
            .attr("d", arc)
            .attr("fill", "none")
            .attr("stroke", d => {
              if (d.source == 2 && d.target == 4) {
                return 'red'
              } else { return 'black' }
            })
            .attr("stroke-width", "0.5")
            .attr('clip-path', 'url(#clipRect)')
        } else if (as_type == "A5SS") {
          as_model.selectAll()
            .data(nodes_links.links)
            .join("path")
            .attr("d", arc)
            .attr("fill", "none")
            .attr("stroke", d => {
              if (d.source == 4 && d.target == 5) {
                return 'red'
              } else { return 'black' }
            })
            .attr("stroke-width", "0.5")
            .attr('clip-path', 'url(#clipRect)')
        } else if (as_type == "MEX") {
          as_model.selectAll()
            .data(nodes_links.links)
            .join("path")
            .attr("d", arc)
            .attr("fill", "none")
            .attr("stroke", d => {
              if ((d.source == 2 && d.target == 5) || (d.source == 6 && d.target == 7)) {
                return 'red'
              } else { return 'black' }
            })
            .attr("stroke-width", "0.5")
            .attr('clip-path', 'url(#clipRect)')
        } else if (as_type == "IR") {
          as_model.selectAll()
            .data(nodes_links.links)
            .join("path")
            .attr("d", arc)
            .attr("fill", "none")
            .attr("stroke", d => {
              if (d.source == 2 && d.target == 3) {
                return 'red'
              } else { return 'black' }
            })
            .attr("stroke-width", "0.5")
            .attr('clip-path', 'url(#clipRect)')
        }
      }

      if (as_type != "Complex" && event_coords && related_exons) {
        // exon skipped (ES)
        if (as_type == "ES") {
          let arr = event_coords.split(":").map(d => +d).sort((a, b) => a - b) // sort coordinates

          // console.log(arr);
          let as_model_exons, as_model_introns, nodes_links, ES_arc;
          if (arr.length == 6) {// ES --- 3 exons
            let upstreamES, upstreamEE, altES, altEE, downstreamES, downstreamEE;
            upstreamES = arr[0];
            upstreamEE = arr[1];
            altES = arr[2];
            altEE = arr[3];
            downstreamES = arr[4];
            downstreamEE = arr[5];
            as_model_exons = [{ "exon": related_exons[0], "start": upstreamES, "end": upstreamEE, "length": upstreamEE - upstreamES + 1, "name": "AS Model", "color": exonColor },
            { "exon": related_exons[1], "start": altES, "end": altEE, "length": altEE - altES + 1, "name": "AS Model", "color": asColor },
            { "exon": related_exons[2], "start": downstreamES, "end": downstreamEE, "length": downstreamEE - downstreamES + 1, "name": "AS Model", "color": exonColor }];
            as_model_introns = [{ "start": upstreamEE, "end": altES, "name": "AS Model" },
            { "start": altEE, "end": downstreamES, "name": "AS Model" }];
            nodes_links = {
              "nodes": [
                {
                  "id": 1,
                  "coordinate": upstreamES
                },
                {
                  "id": 2,
                  "coordinate": upstreamEE
                },
                {
                  "id": 3,
                  "coordinate": altES
                },
                {
                  "id": 4,
                  "coordinate": altEE
                },
                {
                  "id": 5,
                  "coordinate": downstreamES
                },
                {
                  "id": 6,
                  "coordinate": downstreamEE
                },
              ],
              "links": [
                {
                  "source": 2,
                  "target": 3
                },
                {
                  "source": 4,
                  "target": 5
                },
                {
                  "source": 2,
                  "target": 5
                },
              ],
            };
            const allNodes = nodes_links.nodes.map(d => d.coordinate)
            // console.log(allNodes);
            const idToNode = {};
            nodes_links.nodes.forEach(function (n) {
              idToNode[n.id] = n;
            });
            ES_arc = (d) => {
              if (d.source == 2 && d.target == 5) {
                let start = xScale(idToNode[d.source].coordinate) // X position of start node on the X axis
                let end = xScale(idToNode[d.target].coordinate) // X position of end node on the X axis
                return ['M', start, nodesHeight + rectHeight / 2, // the arc starts at the coordinate x=start, y=40 (where the starting node is)
                  'A', // This means we're gonna build an elliptical arc
                  (start - end) / 2, // major axis
                  (start - end) / 6, //minor axis
                  0, 0,
                  start < end ? 0 : 1, // arc lower
                  end, nodesHeight + rectHeight / 2]
                  .join(' ');
              } else {
                let start = xScale(idToNode[d.source].coordinate)
                let end = xScale(idToNode[d.target].coordinate)
                return ['M', start, nodesHeight + rectHeight / 2,
                  'A',
                  (start - end) / 2, // major axis
                  (start - end) / 6, //minor axis
                  0, 0,
                  start < end ? 1 : 0, // arc upper
                  end, nodesHeight + rectHeight / 2]
                  .join(' ');
              }
            }
          } else if (arr.length == 8) {// ES --- 4 exons
            let upstreamES, upstreamEE, alt1ES, alt1EE, alt2ES, alt2EE, downstreamES, downstreamEE;
            upstreamES = arr[0];
            upstreamEE = arr[1];
            alt1ES = arr[2];
            alt1EE = arr[3];
            alt2ES = arr[4];
            alt2EE = arr[5];
            downstreamES = arr[6];
            downstreamEE = arr[7];
            as_model_exons = [{ "exon": related_exons[0], "start": upstreamES, "end": upstreamEE, "length": upstreamEE - upstreamES + 1, "name": "AS Model", "color": exonColor },
            { "exon": related_exons[1], "start": alt1ES, "end": alt1EE, "length": alt1EE - alt1ES + 1, "name": "AS Model", "color": asColor },
            { "exon": related_exons[2], "start": alt2ES, "end": alt2EE, "length": alt2EE - alt2ES + 1, "name": "AS Model", "color": asColor },
            { "exon": related_exons[3], "start": downstreamES, "end": downstreamEE, "length": downstreamEE - downstreamES + 1, "name": "AS Model", "color": exonColor }];
            as_model_introns = [{ "start": upstreamEE, "end": alt1ES, "name": "AS Model" },
            { "start": alt1EE, "end": alt2ES, "name": "AS Model" },
            { "start": alt2EE, "end": downstreamES, "name": "AS Model" }];
            nodes_links = {
              "nodes": [
                {
                  "id": 1,
                  "coordinate": upstreamES
                },
                {
                  "id": 2,
                  "coordinate": upstreamEE
                },
                {
                  "id": 3,
                  "coordinate": alt1ES
                },
                {
                  "id": 4,
                  "coordinate": alt1EE
                },
                {
                  "id": 5,
                  "coordinate": alt2ES
                },
                {
                  "id": 6,
                  "coordinate": alt2EE
                },
                {
                  "id": 7,
                  "coordinate": downstreamES
                },
                {
                  "id": 8,
                  "coordinate": downstreamEE
                },
              ],
              "links": [
                {
                  "source": 2,
                  "target": 3
                },
                {
                  "source": 4,
                  "target": 5
                },
                {
                  "source": 6,
                  "target": 7
                },
                {
                  "source": 2,
                  "target": 7
                },
              ],
            };
            const allNodes = nodes_links.nodes.map(d => d.coordinate)
            // console.log(allNodes);
            const idToNode = {};
            nodes_links.nodes.forEach(function (n) {
              idToNode[n.id] = n;
            });
            ES_arc = (d) => {
              if (d.source == 2 && d.target == 7) {
                let start = xScale(idToNode[d.source].coordinate) // X position of start node on the X axis
                let end = xScale(idToNode[d.target].coordinate) // X position of end node on the X axis
                return ['M', start, nodesHeight + rectHeight / 2, // the arc starts at the coordinate x=start, y=40 (where the starting node is)
                  'A', // This means we're gonna build an elliptical arc
                  (start - end) / 2, // major axis
                  (start - end) / 6, //minor axis
                  0, 0,
                  start < end ? 0 : 1, // arc lower
                  end, nodesHeight + rectHeight / 2]
                  .join(' ');
              } else {
                let start = xScale(idToNode[d.source].coordinate)
                let end = xScale(idToNode[d.target].coordinate)
                return ['M', start, nodesHeight + rectHeight / 2,
                  'A',
                  (start - end) / 2, // major axis
                  (start - end) / 6, //minor axis
                  0, 0,
                  start < end ? 1 : 0, // arc upper
                  end, nodesHeight + rectHeight / 2]
                  .join(' ');
              }
            }
          } else if (arr.length == 10) {// ES --- 5 exons
            let upstreamES, upstreamEE, alt1ES, alt1EE, alt2ES, alt2EE, alt3ES, alt3EE, downstreamES, downstreamEE;
            upstreamES = arr[0];
            upstreamEE = arr[1];
            alt1ES = arr[2];
            alt1EE = arr[3];
            alt2ES = arr[4];
            alt2EE = arr[5];
            alt3ES = arr[6];
            alt3EE = arr[7];
            downstreamES = arr[8];
            downstreamEE = arr[9];
            as_model_exons = [{ "exon": related_exons[0], "start": upstreamES, "end": upstreamEE, "length": upstreamEE - upstreamES + 1, "name": "AS Model", "color": exonColor },
            { "exon": related_exons[1], "start": alt1ES, "end": alt1EE, "length": alt1EE - alt1ES + 1, "name": "AS Model", "color": asColor },
            { "exon": related_exons[2], "start": alt2ES, "end": alt2EE, "length": alt2EE - alt2ES + 1, "name": "AS Model", "color": asColor },
            { "exon": related_exons[3], "start": alt3ES, "end": alt3EE, "length": alt3EE - alt3ES + 1, "name": "AS Model", "color": asColor },
            { "exon": related_exons[4], "start": downstreamES, "end": downstreamEE, "length": downstreamEE - downstreamES + 1, "name": "AS Model", "color": exonColor }];
            as_model_introns = [{ "start": upstreamEE, "end": alt1ES, "name": "AS Model" },
            { "start": alt1EE, "end": alt2ES, "name": "AS Model" },
            { "start": alt2EE, "end": alt3ES, "name": "AS Model" },
            { "start": alt3EE, "end": downstreamES, "name": "AS Model" },
            ];
            nodes_links = {
              "nodes": [
                {
                  "id": 1,
                  "coordinate": upstreamES
                },
                {
                  "id": 2,
                  "coordinate": upstreamEE
                },
                {
                  "id": 3,
                  "coordinate": alt1ES
                },
                {
                  "id": 4,
                  "coordinate": alt1EE
                },
                {
                  "id": 5,
                  "coordinate": alt2ES
                },
                {
                  "id": 6,
                  "coordinate": alt2EE
                },
                {
                  "id": 7,
                  "coordinate": alt3ES
                },
                {
                  "id": 8,
                  "coordinate": alt3EE
                },
                {
                  "id": 9,
                  "coordinate": downstreamES
                },
                {
                  "id": 10,
                  "coordinate": downstreamEE
                },
              ],
              "links": [
                {
                  "source": 2,
                  "target": 3
                },
                {
                  "source": 4,
                  "target": 5
                },
                {
                  "source": 6,
                  "target": 7
                },
                {
                  "source": 8,
                  "target": 9
                },
                {
                  "source": 2,
                  "target": 9
                },
              ],
            };
            const allNodes = nodes_links.nodes.map(d => d.coordinate)
            // console.log(allNodes);
            const idToNode = {};
            nodes_links.nodes.forEach(function (n) {
              idToNode[n.id] = n;
            });
            ES_arc = (d) => {
              if (d.source == 2 && d.target == 9) {
                let start = xScale(idToNode[d.source].coordinate) // X position of start node on the X axis
                let end = xScale(idToNode[d.target].coordinate) // X position of end node on the X axis
                return ['M', start, nodesHeight + rectHeight / 2, // the arc starts at the coordinate x=start, y=40 (where the starting node is)
                  'A', // This means we're gonna build an elliptical arc
                  (start - end) / 2, // major axis
                  (start - end) / 6, //minor axis
                  0, 0,
                  start < end ? 0 : 1, // arc lower
                  end, nodesHeight + rectHeight / 2]
                  .join(' ');
              } else {
                let start = xScale(idToNode[d.source].coordinate)
                let end = xScale(idToNode[d.target].coordinate)
                return ['M', start, nodesHeight + rectHeight / 2,
                  'A',
                  (start - end) / 2, // major axis
                  (start - end) / 6, //minor axis
                  0, 0,
                  start < end ? 1 : 0, // arc upper
                  end, nodesHeight + rectHeight / 2]
                  .join(' ');
              }
            }
          }

          // Plot AS model when init
          // console.log(d3.select('g.as-model')._groups[0][0] == null);
          // console.log(d3.select('g.as-model'));
          if (d3.select('g.as-model')._groups[0][0] == null) {
            plotASModel(as_model_exons, as_model_introns);
          }
          // Plot Nodes and Links for AS Event
          // console.log(d3.select('g.as-model path')._groups[0][0] == null);
          if (d3.select('g.as-model path')._groups[0][0] == null) {
            plotNodesAndLinks(as_type, nodes_links, ES_arc);
          }
        }
        // alternative 3’ splice site (A3SS)
        if (as_type == "A3SS") {
          let arr = event_coords.split(":").map(d => +d).sort((a, b) => a - b) // sort coordinates
          // console.log(arr);
          let flankingES, flankingEE, longES, longEE, shortES, shortEE, as_model_exons, as_model_introns;
          if (strand == "+") {
            flankingES = arr[0];
            flankingEE = arr[1];
            longES = arr[2];
            shortES = arr[3];
            longEE = arr[4];
            shortEE = arr[5];
            as_model_exons = [{ "exon": related_exons[0], "start": flankingES, "end": flankingEE, "length": flankingEE - flankingES + 1, "name": "AS Model", "color": exonColor },
            { "exon": related_exons[1], "start": longES, "end": longEE, "length": longEE - longES + 1, "name": "AS Model", "color": asColor },
            { "exon": related_exons[2], "start": shortES, "end": shortEE, "length": shortEE - shortES + 1, "name": "AS Model", "color": exonColor }];
            as_model_introns = [{ "start": flankingEE, "end": longES, "name": "AS Model" }];
          } else {
            flankingES = arr[5];
            flankingEE = arr[4];
            longES = arr[3];
            shortES = arr[2];
            longEE = arr[1];
            shortEE = arr[0];
            as_model_exons = [{ "exon": related_exons[2], "start": flankingEE, "end": flankingES, "length": flankingES - flankingEE + 1, "name": "AS Model", "color": exonColor },
            { "exon": related_exons[1], "start": longEE, "end": longES, "length": longES - longEE + 1, "name": "AS Model", "color": asColor },
            { "exon": related_exons[0], "start": shortEE, "end": shortES, "length": shortES - shortEE + 1, "name": "AS Model", "color": exonColor }];
            as_model_introns = [{ "start": longES, "end": flankingEE, "name": "AS Model" }];
          }

          let nodes_links = {
            "nodes": [
              {
                "id": 1,
                "coordinate": flankingES
              },
              {
                "id": 2,
                "coordinate": flankingEE
              },
              {
                "id": 3,
                "coordinate": longES
              },
              {
                "id": 4,
                "coordinate": shortES
              },
              {
                "id": 5,
                "coordinate": longEE
              },
              {
                "id": 6,
                "coordinate": shortEE
              },
            ],
            "links": [
              {
                "source": 2,
                "target": 3
              },
              {
                "source": 2,
                "target": 4
              },
            ],
          }
          const allNodes = nodes_links.nodes.map(d => d.coordinate)
          // console.log(allNodes);
          const idToNode = {};
          nodes_links.nodes.forEach(function (n) {
            idToNode[n.id] = n;
          });
          let A3SS_arc = (d) => {
            if (d.source == 2 && d.target == 4) {
              let start = xScale(idToNode[d.source].coordinate) // X position of start node on the X axis
              let end = xScale(idToNode[d.target].coordinate) // X position of end node on the X axis
              return ['M', start, nodesHeight + rectHeight / 2, // the arc starts at the coordinate x=start, y=40 (where the starting node is)
                'A', // This means we're gonna build an elliptical arc
                (start - end) / 2, // major axis
                (start - end) / 6, //minor axis
                0, 0,
                start < end ? 0 : 1, // arc lower
                end, nodesHeight + rectHeight / 2]
                .join(' ');
            } else {
              let start = xScale(idToNode[d.source].coordinate)
              let end = xScale(idToNode[d.target].coordinate)
              return ['M', start, nodesHeight + rectHeight / 2,
                'A',
                (start - end) / 2, // major axis
                (start - end) / 6, //minor axis
                0, 0,
                start < end ? 1 : 0, // arc upper
                end, nodesHeight + rectHeight / 2]
                .join(' ');
            }
          }
          // Plot AS model when init
          // console.log(d3.select('g.as-model')._groups[0][0] == null);
          if (d3.select('g.as-model')._groups[0][0] == null) {
            plotASModel(as_model_exons, as_model_introns);
          }
          // Plot Nodes and Links for AS Event
          // console.log(d3.select('g.as-model path')._groups[0][0] == null);
          if (d3.select('g.as-model path')._groups[0][0] == null) {
            plotNodesAndLinks(as_type, nodes_links, A3SS_arc);
          }
        }
        // alternative 5’ splice site (A5SS)
        if (as_type == "A5SS") {
          let arr = event_coords.split(":").map(d => +d).sort((a, b) => a - b) // sort coordinates
          // console.log(arr);
          let flankingES, flankingEE, longES, longEE, shortES, shortEE, as_model_exons, as_model_introns;
          if (strand == "+") {
            longES = arr[0];
            shortES = arr[1];
            shortEE = arr[2];
            longEE = arr[3];
            flankingES = arr[4];
            flankingEE = arr[5];
            as_model_exons = [{ "exon": related_exons[0], "start": flankingES, "end": flankingEE, "length": flankingEE - flankingES + 1, "name": "AS Model", "color": exonColor },
            { "exon": related_exons[1], "start": longES, "end": longEE, "length": longEE - longES + 1, "name": "AS Model", "color": asColor },
            { "exon": related_exons[2], "start": shortES, "end": shortEE, "length": shortEE - shortES + 1, "name": "AS Model", "color": exonColor }];
            as_model_introns = [{ "start": longEE, "end": flankingES, "name": "AS Model" }];
          } else {
            longES = arr[5];
            shortES = arr[4];
            shortEE = arr[3];
            longEE = arr[2];
            flankingES = arr[1];
            flankingEE = arr[0];
            as_model_exons = [{ "exon": related_exons[2], "start": flankingEE, "end": flankingES, "length": flankingES - flankingEE + 1, "name": "AS Model", "color": exonColor },
            { "exon": related_exons[1], "start": longEE, "end": longES, "length": longES - longEE + 1, "name": "AS Model", "color": asColor },
            { "exon": related_exons[0], "start": shortEE, "end": shortES, "length": shortES - shortEE + 1, "name": "AS Model", "color": exonColor }];
            as_model_introns = [{ "start": longEE, "end": flankingES, "name": "AS Model" }];
          }
          let nodes_links = {
            "nodes": [
              {
                "id": 1,
                "coordinate": longES
              },
              {
                "id": 2,
                "coordinate": shortES
              },
              {
                "id": 3,
                "coordinate": shortEE
              },
              {
                "id": 4,
                "coordinate": longEE
              },
              {
                "id": 5,
                "coordinate": flankingES
              },
              {
                "id": 6,
                "coordinate": flankingEE
              },
            ],
            "links": [
              {
                "source": 3,
                "target": 5
              },
              {
                "source": 4,
                "target": 5
              },
            ],
          }
          const allNodes = nodes_links.nodes.map(d => d.coordinate)
          // console.log(allNodes);
          const idToNode = {};
          nodes_links.nodes.forEach(function (n) {
            idToNode[n.id] = n;
          });
          let A5SS_arc = (d) => {
            if (d.source == 4 && d.target == 5) {
              let start = xScale(idToNode[d.source].coordinate) // X position of start node on the X axis
              let end = xScale(idToNode[d.target].coordinate) // X position of end node on the X axis
              return ['M', start, nodesHeight + rectHeight / 2, // the arc starts at the coordinate x=start, y=40 (where the starting node is)
                'A', // This means we're gonna build an elliptical arc
                (start - end) / 2, // major axis
                (start - end) / 6, //minor axis
                0, 0,
                start < end ? 0 : 1, // arc lower
                end, nodesHeight + rectHeight / 2]
                .join(' ');
            } else {
              let start = xScale(idToNode[d.source].coordinate)
              let end = xScale(idToNode[d.target].coordinate)
              return ['M', start, nodesHeight + rectHeight / 2,
                'A',
                (start - end) / 2, // major axis
                (start - end) / 6, //minor axis
                0, 0,
                start < end ? 1 : 0, // arc upper
                end, nodesHeight + rectHeight / 2]
                .join(' ');
            }
          }
          // Plot AS model when init
          // console.log(d3.select('g.as-model')._groups[0][0] == null);
          if (d3.select('g.as-model')._groups[0][0] == null) {
            plotASModel(as_model_exons, as_model_introns);
          }
          // Plot Nodes and Links for AS Event
          // console.log(d3.select('g.as-model path')._groups[0][0] == null);
          if (d3.select('g.as-model path')._groups[0][0] == null) {
            plotNodesAndLinks(as_type, nodes_links, A5SS_arc);
          }
        }
        // mutually exclusive exons (MEX)
        if (as_type == "MEX") {
          let arr = event_coords.split(":").map(d => +d).sort((a, b) => a - b) // sort coordinates
          // console.log(arr);
          let upstreamES, upstreamEE, firstExonStart, firstExonEnd, secnodExonStart, secnodExonEnd, downstreamES, downstreamEE, as_model_exons, as_model_introns;
          if (strand == "+") {
            upstreamES = arr[0];
            upstreamEE = arr[1];
            firstExonStart = arr[2];
            firstExonEnd = arr[3];
            secnodExonStart = arr[4];
            secnodExonEnd = arr[5];
            downstreamES = arr[6];
            downstreamEE = arr[7];
            as_model_exons = [{ "exon": related_exons[0], "start": upstreamES, "end": upstreamEE, "length": upstreamEE - upstreamES + 1, "name": "AS Model", "color": exonColor },
            { "exon": related_exons[1], "start": firstExonStart, "end": firstExonEnd, "length": firstExonEnd - firstExonStart + 1, "name": "AS Model", "color": asColor },
            { "exon": related_exons[2], "start": secnodExonStart, "end": secnodExonEnd, "length": secnodExonEnd - secnodExonStart + 1, "name": "AS Model", "color": asColor },
            { "exon": related_exons[3], "start": downstreamES, "end": downstreamEE, "length": downstreamEE - downstreamES + 1, "name": "AS Model", "color": exonColor }];
            as_model_introns = [{ "start": upstreamEE, "end": firstExonStart, "name": "AS Model" },
            { "start": firstExonEnd, "end": secnodExonStart, "name": "AS Model" },
            { "start": secnodExonEnd, "end": downstreamES, "name": "AS Model" }];
          } else {
            upstreamES = arr[7];
            upstreamEE = arr[6];
            firstExonStart = arr[5];
            firstExonEnd = arr[4];
            secnodExonStart = arr[3];
            secnodExonEnd = arr[2];
            downstreamES = arr[1];
            downstreamEE = arr[0];
            as_model_exons = [{ "exon": related_exons[3], "start": upstreamEE, "end": upstreamES, "length": upstreamES - upstreamEE + 1, "name": "AS Model", "color": exonColor },
            { "exon": related_exons[2], "start": firstExonEnd, "end": firstExonStart, "length": firstExonStart - firstExonEnd + 1, "name": "AS Model", "color": asColor },
            { "exon": related_exons[1], "start": secnodExonEnd, "end": secnodExonStart, "length": secnodExonStart - secnodExonEnd + 1, "name": "AS Model", "color": asColor },
            { "exon": related_exons[0], "start": downstreamEE, "end": downstreamES, "length": downstreamES - downstreamEE + 1, "name": "AS Model", "color": exonColor }];
            as_model_introns = [{ "start": firstExonStart, "end": upstreamEE, "name": "AS Model" },
            { "start": secnodExonStart, "end": firstExonEnd, "name": "AS Model" },
            { "start": downstreamES, "end": secnodExonEnd, "name": "AS Model" }];
          }

          let nodes_links = {
            "nodes": [
              {
                "id": 1,
                "coordinate": upstreamES
              },
              {
                "id": 2,
                "coordinate": upstreamEE
              },
              {
                "id": 3,
                "coordinate": firstExonStart
              },
              {
                "id": 4,
                "coordinate": firstExonEnd
              },
              {
                "id": 5,
                "coordinate": secnodExonStart
              },
              {
                "id": 6,
                "coordinate": secnodExonEnd
              },
              {
                "id": 7,
                "coordinate": downstreamES
              },
              {
                "id": 8,
                "coordinate": downstreamEE
              },
            ],
            "links": [
              {
                "source": 2,
                "target": 3
              },
              {
                "source": 4,
                "target": 7
              },
              {
                "source": 2,
                "target": 5
              },
              {
                "source": 6,
                "target": 7
              },
            ],
          }
          const allNodes = nodes_links.nodes.map(d => d.coordinate)
          // console.log(allNodes);
          const idToNode = {};
          nodes_links.nodes.forEach(function (n) {
            idToNode[n.id] = n;
          });
          let MEX_arc = (d) => {
            if ((d.source == 2 && d.target == 5) || (d.source == 6 && d.target == 7)) {
              let start = xScale(idToNode[d.source].coordinate) // X position of start node on the X axis
              let end = xScale(idToNode[d.target].coordinate) // X position of end node on the X axis
              return ['M', start, nodesHeight + rectHeight / 2, // the arc starts at the coordinate x=start, y=40 (where the starting node is)
                'A', // This means we're gonna build an elliptical arc
                (start - end) / 2, // major axis
                (start - end) / 10, //minor axis
                0, 0,
                start < end ? 0 : 1, // arc lower
                end, nodesHeight + rectHeight / 2]
                .join(' ');
            } else {
              let start = xScale(idToNode[d.source].coordinate)
              let end = xScale(idToNode[d.target].coordinate)
              return ['M', start, nodesHeight + rectHeight / 2,
                'A',
                (start - end) / 2, // major axis
                (start - end) / 10, //minor axis
                0, 0,
                start < end ? 1 : 0, // arc upper
                end, nodesHeight + rectHeight / 2]
                .join(' ');
            }
          }
          // Plot AS model when init
          // console.log(d3.select('g.as-model')._groups[0][0] == null);
          if (d3.select('g.as-model')._groups[0][0] == null) {
            plotASModel(as_model_exons, as_model_introns);
          }
          // Plot Nodes and Links for AS Event
          // console.log(d3.select('g.as-model path')._groups[0][0] == null);
          if (d3.select('g.as-model path')._groups[0][0] == null) {
            plotNodesAndLinks(as_type, nodes_links, MEX_arc);
          }
        }
        // intron retained (IR)
        if (as_type == "IR") {
          let arr = event_coords.split(":").map(d => +d).sort((a, b) => a - b) // sort coordinates
          // console.log(arr);
          let upstreamES = arr[0];
          let upstreamEE = arr[1];
          let downstreamES = arr[2];
          let downstreamEE = arr[3];
          let as_model_exons = [{ "exon": related_exons[0], "start": upstreamES, "end": upstreamEE, "length": upstreamEE - upstreamES + 1, "name": "AS Model", "color": asColor },
          { "exon": related_exons[1], "start": downstreamES, "end": downstreamEE, "length": downstreamEE - downstreamES + 1, "name": "AS Model", "color": asColor }];
          let as_model_introns = [{ "start": upstreamEE, "end": downstreamES, "name": "AS Model" }
          ];
          let nodes_links = {
            "nodes": [
              {
                "id": 1,
                "coordinate": upstreamES
              },
              {
                "id": 2,
                "coordinate": upstreamEE
              },
              {
                "id": 3,
                "coordinate": downstreamES
              },
              {
                "id": 4,
                "coordinate": downstreamEE
              },
            ],
            "links": [
              // {
              //   "source": 1,
              //   "target": 2
              // },
              // {
              //   "source": 3,
              //   "target": 4
              // },
              {
                "source": 2,
                "target": 3
              },
            ],
          }
          const allNodes = nodes_links.nodes.map(d => d.coordinate)
          // console.log(allNodes);
          const idToNode = {};
          nodes_links.nodes.forEach(function (n) {
            idToNode[n.id] = n;
          });
          let IR_arc = (d) => {
            if (d.source == 2 && d.target == 3) {
              let start = xScale(idToNode[d.source].coordinate) // X position of start node on the X axis
              let end = xScale(idToNode[d.target].coordinate) // X position of end node on the X axis
              return ['M', start, nodesHeight + rectHeight / 2, // the arc starts at the coordinate x=start, y=40 (where the starting node is)
                'A', // This means we're gonna build an elliptical arc
                (start - end) / 2, // major axis
                (start - end) / 4, //minor axis
                0, 0,
                start < end ? 0 : 1, // arc lower
                end, nodesHeight + rectHeight / 2]
                .join(' ');
            } else {
              let start = xScale(idToNode[d.source].coordinate)
              let end = xScale(idToNode[d.target].coordinate)
              return ['M', start, nodesHeight + rectHeight / 2,
                'A',
                (start - end) / 2, // major axis
                (start - end) / 6, //minor axis
                0, 0,
                start < end ? 1 : 0, // arc upper
                end, nodesHeight + rectHeight / 2]
                .join(' ');
            }
          }
          // Plot AS model when init
          // console.log(d3.select('g.as-model')._groups[0][0] == null);
          if (d3.select('g.as-model')._groups[0][0] == null) {
            plotASModel(as_model_exons, as_model_introns);
          }
          // Plot Nodes and Links for AS Event
          // console.log(d3.select('g.as-model path')._groups[0][0] == null);
          if (d3.select('g.as-model path')._groups[0][0] == null) {
            plotNodesAndLinks(as_type, nodes_links, IR_arc);
          }
          // Add brush for context
          // addBrush(nodes_links, IR_arc)
        }

        // paint arrow
        svg.append('g')
          .append("marker")
          .attr("id", "arrow")
          .attr("markerUnits", "strokeWidth") //设置为strokeWidth箭头会随着线的粗细发生变化
          .attr("viewBox", "0 0 10 10") //坐标系的区域
          .attr("refX", 6) //箭头坐标
          .attr("refY", 6)
          .attr("markerWidth", 12)
          .attr("markerHeight", 12)
          // .attr("orient", "auto") //绘制方向，可设定为：auto（自动确认方向）和 角度值
          .attr("orient", "auto-start-reverse") //绘制方向，可设定为：auto-start-reverse 和 角度值
          .append("path")
          .attr("d", "M2,2 L10,6 L2,10 L6,6 L2,2") //箭头的路径
          .attr('fill', 'black')//箭头颜色
          .attr('opacity', 0.5);

        // 绘制与箭头相连的直线
        let arrowline = svg.append('g').append("line")
          .attr("x1", margin.left)
          .attr("y1", height / 2 + rectHeight + 30)
          .attr("x2", width - margin.right)
          .attr("y2", height / 2 + rectHeight + 30)
          .attr('fill', "none")
          .attr("stroke", "black")
          .attr("stroke-width", 0.5)
          .attr('stroke-opacity', 0.5)
          .attr('stroke-dasharray', (6, 5))
        // .attr("marker-start", "url(#arrow)");

        // 根据正负链判断箭头方向，并在箭头上方添加文字
        // console.log(strand);
        if (strand == "+") {
          arrowline.attr("marker-end", "url(#arrow)")
          svg.append('g').append("text").attr("x", margin.left).attr("y", height / 2 + rectHeight + 40).text("5'").attr('font-size', 8).attr('opacity', 0.8)
          svg.append('g').append("text").attr("x", width - margin.right - 5).attr("y", height / 2 + rectHeight + 40).text("3'").attr('font-size', 8).attr('opacity', 0.8)
        } else {
          arrowline.attr("marker-start", "url(#arrow)")
          svg.append('g').append("text").attr("x", margin.left).attr("y", height / 2 + rectHeight + 40).text("3'").attr('font-size', 8).attr('opacity', 0.8)
          svg.append('g').append("text").attr("x", width - margin.right - 5).attr("y", height / 2 + rectHeight + 40).text("5'").attr('font-size', 8).attr('opacity', 0.8)
        }
      }
    },
  },
}
</script>

<style lang="sass" scoped>
a
  text-decoration: none
  color: #2196F3

a:hover
  text-decoration: underline

.v-data-table ::v-deep th
  font-size: 0.87rem !important
.v-data-table ::v-deep td
  font-size: 0.875rem !important

.v-btn
  text-transform: none
  letter-spacing: 0em
  font-size: 0.875rem

.v-expansion-panel--active > .v-expansion-panel-header
  min-height: 45px

.v-list-item__title
  font-size: 0.875rem !important

.description
  width: 100%
  display: -webkit-box
  -webkit-box-orient: vertical
  overflow: hidden

.v-card__title
  line-height: 0.5rem

.breadcrumb
  line-height: 1
  display: inline-block
  margin: 0 0
  vertical-align: middle
  padding: 8px 15px
  margin-top: -5px
  margin-bottom: 10px
  list-style: none
  background-color: #f5f5f5
  border-radius: 4px

.v-item-group
  flex: 0 1 auto
  position: relative
  display: inline-flex
  flex-wrap: wrap
  max-width: 100%
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1)

.data-table-style
  border: thin solid rgba(0, 0, 0, 0.12)

.side_bar
  position: fixed
  right: 1%
  top: 370px
  transform: translateY(-50%)
</style>